import { ConfigStates } from 'types/config';

export const HOME_PATH = '/';
export const HORIZONTAL_MAX_ITEM = 7;

export const CSS_VAR_PREFIX = '';

export enum MenuOrientation {
  VERTICAL = 'vertical',
  HORIZONTAL = 'horizontal'
}

export enum ThemeMode {
  LIGHT = 'light',
  DARK = 'dark',
  SYSTEM = 'system'
}

export enum ThemeDirection {
  LTR = 'ltr',
  RTL = 'rtl'
}

export enum DropzopType {
  default = 'DEFAULT',
  standard = 'STANDARD'
}

export const DEFAULT_THEME_MODE: ThemeMode = ThemeMode.LIGHT;

const config: ConfigStates = {
  menuOrientation: MenuOrientation.VERTICAL,
  miniDrawer: false,
  fontFamily: `'Poppins', sans-serif`,
  borderRadius: 10,
  outlinedFilled: true,
  presetColor: 'default',
  i18n: 'hu',
  themeDirection: ThemeDirection.LTR,
  container: true
};

export default config;
